export default __webpack_public_path__ + "static/media/Edit.d2a44e35.svg";